import "./index.scss"

// import {scrollPage} from "./scripts/scrollPage";
// import {toggleVideoSound} from "./scripts/toggleVideoSound";
// import {showHeader} from "./scripts/showHeader";
import {reviewsAnimation} from "./scripts/reviewsAnimation";
import {textAnimation} from "./scripts/textAnimation";
// import {textAnimationHome} from "./scripts/textAnimationHome";

window.addEventListener('DOMContentLoaded', function () {
  // textAnimationHome();
  textAnimation();
  amzn('trackEvent', 'SLKPageView');
});

document.addEventListener('scroll', function () {
  reviewsAnimation();
  textAnimation();
  // showHeader();
})

document.querySelectorAll('.btn--play').forEach(btn => {
  btn.addEventListener('click', function () {
    amzn("trackEvent", "SLKPlayNow");
  });
})

document.querySelector('.btn-download').addEventListener('click', function () {
  amzn("trackEvent", "SLKPlayNow");
});


document.addEventListener('click', (evt) => {
  let el = evt.target;

  if (!el.closest('.btn')) {
    return
  }

  // evt.preventDefault();

  if (el.closest('.btn--play')) {
    onBtnMore();
  }

  if (el.closest('.btn-download')) {
    onBtnMore();
  }
})

function onBtnMore() {
  if (isAndroid() || isIos()) {
    return false;
  }
  
  document.querySelector('.instruction').classList.remove('hide');
  document.querySelector('body').style.overflow = 'hidden';
}

function isAndroid() {
  return /(android)/i.test(navigator.userAgent);
}

function isIos() {
  return navigator.platform.startsWith("iP") || navigator.platform.startsWith("Mac");
}


$(function() {
  var body = $('#starshine'),
      template = $('.template.shine'),
      stars =  400,
      sparkle = 20;
  
    
  var size = 'small';
  var createStar = function() {
    template.clone().removeAttr('id').css({
      top: (Math.random() * 100) + '%',
      left: (Math.random() * 100) + '%',
      webkitAnimationDelay: (Math.random() * sparkle) + 's',
      mozAnimationDelay: (Math.random() * sparkle) + 's'
    }).addClass(size).appendTo(body);
  };
 
  for(var i = 0; i < stars; i++) {
    if(i % 2 === 0) {
      size = 'small';
    } else if(i % 3 === 0) {
      size = 'medium';
    } else {
      size = 'large';
    }
    
    createStar();
  }
});

